import { DEFAULT_GETTERS } from '@/constants'

export default {
  ...DEFAULT_GETTERS,
  listMemberContactInfo: state => state.listMemberContactInfo,
}
